module.exports = __webpack_public_path__ + "img/socupv2.c1de652d.svg";